import React from 'react';

function StaticFooterView (props) {
  return (
    <div dangerouslySetInnerHTML={props.template} />
  );
}

export default StaticFooterView;